/* istanbul ignore file */
/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  purchaseHistory: {
    name: 'purchaseHistory',
    componentName: 'PurchaseHistory',
    chunk: () =>
      import(
        /* webpackChunkName: "purchaseHistory" */
        './pages/PurchaseHistory'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/PurchaseHistory'),
          ).PurchaseHistory
        : currentRouteName === 'purchaseHistory'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PurchaseHistory,
            })),
          );
    },
    path: '/:context?/myaccount/purchase-history',
    prefetch: [],
    channel: null,
  },
  searchResults: {
    name: 'searchResults',
    componentName: 'SearchResults',
    chunk: () =>
      import(
        /* webpackChunkName: "searchResults" */
        './pages/SearchResults'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/SearchResults'),
          ).SearchResults
        : currentRouteName === 'searchResults'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.SearchResults,
            })),
          );
    },
    path: '/:context?/myaccount/purchase-history/search-results',
    prefetch: [],
    channel: null,
  },
  orderDetails: {
    name: 'orderDetails',
    componentName: 'OrderDetails',
    chunk: () =>
      import(
        /* webpackChunkName: "orderDetails" */
        './pages/OrderDetails'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/OrderDetails'),
          ).OrderDetails
        : currentRouteName === 'orderDetails'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.OrderDetails,
            })),
          );
    },
    path: '/:context?/myaccount/order-details',
    prefetch: [],
    channel: null,
  },
  cancelItems: {
    name: 'cancelItems',
    componentName: 'CancelItems',
    chunk: () =>
      import(
        /* webpackChunkName: "cancelItems" */
        './pages/CancelItems'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/CancelItems'))
            .CancelItems
        : currentRouteName === 'cancelItems'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.CancelItems,
            })),
          );
    },
    path: '/:context?/myaccount/cancel-items',
    prefetch: [],
    channel: null,
  },
  linkedAccounts: {
    name: 'linkedAccounts',
    componentName: 'LinkedAccounts',
    chunk: () =>
      import(
        /* webpackChunkName: "linkedAccounts" */
        './pages/LinkedAccounts'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/LinkedAccounts'),
          ).LinkedAccounts
        : currentRouteName === 'linkedAccounts'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.LinkedAccounts,
            })),
          );
    },
    path: '/:context?/myaccount/linked-accounts',
    prefetch: [],
    channel: null,
  },
  guestOrderTracking: {
    name: 'guestOrderTracking',
    componentName: 'GuestOrderTracking',
    chunk: () =>
      import(
        /* webpackChunkName: "guestOrderTracking" */
        './pages/GuestOrderTracking'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/GuestOrderTracking'),
          ).GuestOrderTracking
        : currentRouteName === 'guestOrderTracking'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.GuestOrderTracking,
            })),
          );
    },
    path: '/:context?/myaccount/guest-order-tracking',
    prefetch: [],
    channel: null,
  },
  downloads: {
    name: 'downloads',
    componentName: 'Downloads',
    chunk: () =>
      import(
        /* webpackChunkName: "downloads" */
        './pages/Downloads'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Downloads.tsx'),
          ).Downloads
        : currentRouteName === 'downloads'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Downloads,
            })),
          );
    },
    path: '/:context?/myaccount/downloads',
    prefetch: [],
    channel: null,
  },
  businessTools: {
    name: 'businessTools',
    componentName: 'BusinessTools',
    chunk: () =>
      import(
        /* webpackChunkName: "businessTools" */
        './pages/BusinessTools'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/BusinessTools.tsx'),
          ).BusinessTools
        : currentRouteName === 'businessTools'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.BusinessTools,
            })),
          );
    },
    path: '/:context?/myaccount/business-tools',
    prefetch: ['verification'],
    channel: null,
  },
  subscriptions: {
    name: 'subscriptions',
    componentName: 'Subscriptions',
    chunk: () =>
      import(
        /* webpackChunkName: "subscriptions" */
        './pages/Subscriptions'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Subscriptions.tsx'),
          ).Subscriptions
        : currentRouteName === 'subscriptions'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Subscriptions,
            })),
          );
    },
    path: '/:context?/myaccount/ordersubscription',
    prefetch: ['verification'],
    channel: null,
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/Home'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.tsx'))
            .Home
        : currentRouteName === 'home'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Home,
            })),
          );
    },
    path: '/:context?/myaccount/home',
    prefetch: [],
    channel: null,
  },
});
